import { TimeRangeInterface } from '../../..';
import { TimeDto } from './time.dto';

export class OpeningHoursDayDto implements TimeRangeInterface {
  timeStart: TimeDto;
  timeEnd: TimeDto;
}
